import React from 'react'
import { LocalityNameViewModel } from './LocalityNameViewModel';
import { NavBarComponente } from '../../Components/NavBarComponente';
import { Container, Row, Image, Col, Form, Button } from 'react-bootstrap';
import fechar from '../../Imagens/close-24.png';
import salvar from '../../Imagens/save-16.png';

import "../../Estilo/Form.css";
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import { AddressViewModel } from '../Address/AddressViewModel';
import { InputModalSelectComponent } from '../../Components/InputModalSelectComponent';
import Select from 'react-select';

interface MyProps {
    navigation: any
    delegate: LocalityNameViewControllerDelegate
    viewModel: LocalityNameViewModel
    idPrimary: number
}

export interface LocalityNameViewControllerDelegate {
    tapDimiss(navigation: any): void
}

export class LocalityNameViewController extends React.Component<MyProps> {

    private formEvent: FormEvent
    state = {
        isLoading: false,
        json: {},
        neighborhood: [],
        district: [],
        zoning: [],
    }

    constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
    }

    componentDidMount() {
        this.loadSelect()
        if (this.props.idPrimary > 0) {
            this.loadStruct()
        }
    }

    render() {
        var json = this.state.json as any
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation} />
                <div>
                    <Container fluid={true}>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Nome Localidade</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                        onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                        src={fechar} />
                                </div>
                            </Col>
                        </Row>
                        <Form className="containerForm">
                            <Row>
                                <Col lg="4" xs="12" className="bottom10 hide">
                                    <Form.Label>Sequencial</Form.Label>
                                    <Form.Control
                                        id="sgepnomelocalidade"
                                        defaultValue={json['sgepnomelocalidade'] ? json['sgepnomelocalidade'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("inteiro", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Codigo</Form.Label>
                                    <Form.Control
                                        id="codigo"
                                        defaultValue={json['codigo'] ? json['codigo'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                        placeholder="Digite o codigo"
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Bairro</Form.Label>
                                    <Select
                                        id="sgepbairros"
                                        value={this.formEvent.onValueSelect('select', 'sgepbairros', this.state.neighborhood)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "sgepbairros")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.neighborhood}
                                        isMulti={false}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Distrito</Form.Label>
                                    <Select
                                        id="sgepdistrito"
                                        value={this.formEvent.onValueSelect('select', 'sgepdistrito', this.state.district)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "sgepdistrito")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.district}
                                        isMulti={false}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" style={{ marginTop: 20 }}>
                                    <Button className="buttonSave" type="button" onClick={(e: any) => this.save()} variant="primary">
                                        <Image className="imageSave"
                                            src={salvar} />
                                        Salvar
                                    </Button>
                                    <Button onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)} className="buttonCancel" variant="link">Cancelar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <ToastContainer />
                    </Container>
                </div>
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({ isLoading: this.state.isLoading })} />
            </div>
        )
    }

    private save() {
        var json = this.state.json as any
        if (!json["codigo"]) {
            this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
            return
        }

        this.props.viewModel.fetchSave(json).then(() => {
            toast.success("Registro incluído com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            setTimeout(() => {
                this.props.delegate.tapDimiss(this.props.navigation);
            }, 1000);
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }

    private showFieldsEmpty(message: string) {
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }
    private loadSelect() {
        const addressViewModel = new AddressViewModel()
        addressViewModel.fetchSelectProperty().then((rs) => {
            var json = rs.length > 0 ? rs[0] : {} as any
            var keys = Object.keys(json)

            for (var i = 0; i < keys.length; i++) {
                var array = Array<any>()
                var result = json[keys[i]] as Array<any>

                for (var a = 0; a < result.length; a++) {
                    var item = result[a]
                    array.push({ value: item.id, label: item.value, check: false })
                }
                switch (keys[i]) {
                    case "gepbairros":
                        this.setState({ neighborhood: array })
                        break;
                    case "gepdistrito":
                        this.setState({ district: array })
                        break;
                    case "gepzoneamento":
                        this.setState({ zoning: array })
                        break;
                }
            }
        })
    }
    private setCity(id: number, value: string) {
        var json = this.state.json as any
        json['ccidade'] = id
        json['municipio'] = value

        this.setState({
            json: json
        })
    }
    private loadStruct() {
        var json = this.state.json as any
        json['sgepnomelocalidade'] = this.props.idPrimary

        this.setState({ isLoading: true })
        this.props.viewModel.fetchDataOne(json).then((rs) => {
            var resultado = rs as Array<any>
            if (resultado.length > 0) {
                this.setState({
                    isLoading: false,
                    json: resultado[0]
                })

                return
            }

            this.setState({ isLoading: false })
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }
}